// extracted by mini-css-extract-plugin
module.exports = {"nav":"MainMenu_nav__z9Svm","navBar":"MainMenu_navBar__mKQra","navbarToggle":"MainMenu_navbarToggle__ZcDh2","navbar-toggler-icon":"MainMenu_navbar-toggler-icon__GI_6B"};